import React from "react"
import { Icon } from "antd"
import WordCloud from "./wordCloud"
import "./index.scss"
const Tabs = [
  { name: "", key: "aoi", com: WordCloud },
  { name: "云信息", key: "cloud", com: Cloud },
  { name: "路径分析", key: "path", com: Path },
]
export default class Panels extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cur: 0,
      show: true,
    }
  }
  changeTab = i => {
    this.setState({ cur: i })
  }
  componentDidMount() {}
  toggle = () => {
    this.setState({ show: !this.state.show })
  }
  render() {
    let { cur, show } = this.state
    return (
      <div
        className={"chart-panel tra-chart-panel" + (show ? "" : " panel-hide")}
      >
        <div className="panel-toggler" onClick={this.toggle}>
          <Icon type={show ? "left" : "right"} />
        </div>
        <div className="panel-inner">
          {/* <div className="panel-tab">
            {Tabs.map((tab, i) => {
              return (
                <div
                  key={i}
                  className={i === cur ? "active" : ""}
                  onClick={() => {
                    this.changeTab(i)
                  }}
                >
                  {tab.name}
                </div>
              )
            })}
          </div> */}
          <div className="panel-con">
            {Tabs.map((tab, i) => {
              return (
                <div
                  key={i}
                  className={
                    "panel-con-" + tab.key + (i === cur ? " active" : "")
                  }
                >
                  {tab.name ? (
                    <div className="panel-con-title">{tab.name}</div>
                  ) : null}
                  <tab.com {...this.props} />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

function Cloud({ curPoi }) {
  let res = ["上海市", "虹口区", "鲁迅公园", "虹叶花苑", "房地产"]
  if (curPoi) {
    res[0] = curPoi.city
    res[1] = curPoi.area
    res[2] = curPoi.bussiness || curPoi.name
    res[3] = curPoi.community || curPoi.name
    res[4] = curPoi.tag
  }
  return (
    <div className="panel-cloud">
      <div className="cloud-field">
        <div>市</div>
        <div>区</div>
        <div>商圈</div>
        <div>区域名</div>
        <div>标签</div>
      </div>
      <div className="cloud-info">
        {res.map((n, i) => {
          return <div key={i}>{n}</div>
        })}
      </div>
    </div>
  )
}

function Path() {
  return (
    <div className="panel-path">
      <ul>
        <li>
          <i className="icon-car Monday" />
          星期一 虹叶花苑 &lt;---&gt;上海师大
        </li>
        <li>
          <i className="icon-car Tuesday" />
          星期二 虹叶花苑 &lt;---&gt;上海师大
        </li>
        <li>
          <i className="icon-car Wednesday" />
          星期三 虹叶花苑 &lt;---&gt;上海师大
        </li>
        <li>
          <i className="icon-car Thursday" />
          星期四 虹叶花苑 &lt;---&gt;上海师大
        </li>
        <li>
          <i className="icon-car Friday" />
          星期五 虹叶花苑--&gt;上海师大--&gt;恬润新苑
        </li>
        <li>
          <i className="icon-car Saturday" />
          星期六 恬润新苑 &lt;---&gt;新理想花园
        </li>
        <li>
          <i className="icon-car Sunday" />
          星期天 恬润新苑 &lt;---&gt;虹叶花苑
        </li>
      </ul>
    </div>
  )
}
